
<div :id="content.idHTML" class="pannel-body px-2 py-2">
  <ValidationObserver ref="observer" v-slot="{ invalid }" :vid="'vobserver' + uniqueId" tag="div">
    <b-form :id="'idFormulaire' + uniqueId" @submit.stop.prevent="onSubmit($event)">
      <div v-show="isErreurServeur">
        <MessageMel
          v-show="contentMessageMel.message"
          :content="contentMessageMel.message"
          class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
        ></MessageMel>
      </div>
      <Paragraphe
        :content="{
          richText: content.libNouvelleLimite,
          classeCSS: 'pt-1',
        }"
        class="titre-legal"
      ></Paragraphe>
      <GroupeRadio
        v-model="choix"
        :content="contentGroupeRadio"
        @input="setLimitValue"
      ></GroupeRadio>
      <div class="btn-rigth">
        <b-button
          type="submit"
          variant="tertiaire"
          class="btn btn-primaire-limite px-6 mb-0"
          :disabled="invalid || isSubmitted"
        >
          <div class="">
            <div v-if="isSubmitted" class="mr-1">
              <b-spinner small :label="$t('chargement')"></b-spinner>
            </div>
            <span class="">{{ content.libBtnConfirmer }}</span>
          </div>
        </b-button>
      </div>
      <Paragraphe
        v-if="category !== 'deposit'"
        :content="{
          richText: getContentTxtDelais,
          classeCSS: 'pt-1',
        }"
        class="texte-legal"
      ></Paragraphe>
    </b-form>
  </ValidationObserver>
</div>
